import React from 'react';
import cx from 'clsx';
import { Icon } from '@printdeal/ui-library';

interface ReviewStarsProps {
  score: number;
  className?: string;
}

type StarType = 'full' | 'half' | 'blank';

export const getStarCount = (score: number): number => Math.round(((score / 2) * 2)) / 2;

const Star = ({ type, className }: { type: StarType, className?: string }) => {
  const testAttribute = `review-star-${type}`;

  if (type !== 'half') {
    return <Icon icon="star" className={cx(className, 'pd-text-[24px]', type === 'blank' ? 'pd-text-dim-200' : 'pd-text-primary-500')} data-testid={testAttribute} />;
  }

  return (
    <div className={cx('pd-w-em pd-flex pd-relative pd-text-[24px]', className)} data-testid={testAttribute}>
      <Icon icon="star" className="pd-absolute pd-text-dim-200" />
      <Icon icon="star-half" className="pd-absolute pd-text-primary-500" />
    </div>
  );
};

export const getStarLayout = (starCount: number): StarType[] => {
  const baseArray = ['blank', 'blank', 'blank', 'blank', 'blank'];
  const starTrunc = Math.trunc(starCount);

  if (starCount === 0) return baseArray as StarType[];

  const starLayout = baseArray.fill('full', 0, starTrunc);

  if (starCount % 1 !== 0) {
    starLayout.fill('half', starTrunc, starTrunc + 1);
  }

  return starLayout as StarType[];
};

export const ReviewStars = ({ score, className }: ReviewStarsProps) => {
  if (typeof score !== 'number') return null;

  const starCount = getStarCount(score);
  const starLayout = getStarLayout(starCount);
  const indexedLayout = starLayout.map((type, index) => ({ type, key: index }));

  return (
    <div className={cx('pd-flex pd-gap-1', className)} aria-hidden>
      {indexedLayout.map(({ type, key }) =>
        <Star type={type} key={key} />)}
    </div>
  );
};
